var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{attrs:{"size":(_vm.xSmall) ? 30 : (_vm.small) ? 50 : 70,"color":_vm.buttonColor,"width":(_vm.xSmall) ? 3 : (_vm.small) ? 5 : 7,"indeterminate":""}})}
var staticRenderFns = []

export { render, staticRenderFns }